import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const CodigosPanel = () => {
  const [codigos, setCodigos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const fetchCodigos = async () => {
    try {
      setLoading(true);
      const res = await api.get('/codigos');
      setCodigos(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCodigos(); }, []);

  const handleEdit = (codigo) => {
    setSelected({ ...codigo });
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(codigos.find(c => c.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    if (selected) {
      await api.put(`/codigos/${selected.id}`, formData);
    } else {
      await api.post('/codigos', { codigo_unico: formData.codigo_unico });
    }
    setShowEdit(false);
    fetchCodigos();
  };

  const confirmDelete = async () => {
    await api.delete(`/codigos/${selected.id}`);
    setShowDelete(false);
    fetchCodigos();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'codigo_unico', label: 'Código' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Códigos QR</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={codigos}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar código' : 'Crear código'}
          fields={[
            { name: 'codigo_unico', label: 'Código único (formato AAAA0000)' },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar el código ${selected.codigo_unico}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default CodigosPanel;